<div class="container reserves-page">
  <div class="row">
    <div class="col-md-10 ms-auto me-auto">
      <h2 class="title">{{'reserves.myReserves'|traduccion}}</h2>
    </div>
  </div>

  <div class="row">
    <div class="col-md-10 ms-auto me-auto">
      <div class="card reserves-shell">
        <div class="card-header reserves-shell__header">
          <div class="reserves-shell__count">
            {{'reserves.total'|traduccion}}: <strong>{{reserves.length}}</strong>
          </div>
        </div>

        <div class="card-body reserves-shell__body">
          @for (reserve of reserves; track reserve) {
            <div [class.inactive]="!reserve.active" class="reserve-card">
              <div class="reserve-card__top">
                <div class="reserve-card__identity">
                  <a target="_blank" [routerLink]="language.path('reserve/visor')" title="{{'reserves.details'|traduccion}}"
                    [queryParams]="{code:getLastLine(reserve)}" class="btn btn-info btn-round reserve-card__details">
                    <i class="nc-icon nc-paper text-dark"></i>
                  </a>
                  <div class="reserve-card__title-block">
                    <div class="reserve-card__eyebrow">{{'reserves.tLocker'|traduccion}}</div>
                    <div class="reserve-card__title">{{ reserve.categoryCode }}</div>
                  </div>
                </div>
                <div class="reserve-card__meta">
                  <div class="reserve-meta-card">
                    <div class="reserve-meta-card__label">{{'reserves.address'|traduccion}}</div>
                    <div class="reserve-meta-card__value">
                      {{ reserve.location.name }}
                    </div>
                    <div class="reserve-meta-card__label">{{'reserves.nLocker'|traduccion}}</div>
                    <div class="reserve-meta-card__value">
                      {{ reserve.lockerId != 0 ? reserve.lockerId : ('reserves.lockerNoSet'|traduccion) }}
                    </div>
                  </div>
                  <div class="reserve-meta-card reserve-meta-card--period">
                    <div class="reserve-meta-card__label">{{'reserves.period'|traduccion}}</div>
                    <div class="reserve-meta-card__value">
                      <span>{{ reserve.startTime | date: appService.FORMAT_DATETIME }}</span>
                      <span>{{ reserve.endTime | date: appService.FORMAT_DATETIME }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="reserve-card__section">
                <div class="row">
                  <div class="col-lg-4 col-md-6 mb-3">
                    <div class="pin-card">
                      <label class="pin-card__label" for="passC-{{reserve.uuid}}">
                        {{'reserves.checkoutPassword'|traduccion}}
                      </label>
                      <div class="pin-card__preview">{{formatPin(reserve, passC.value)}}</div>
                      <input id="passC-{{reserve.uuid}}" #passC type="text" class="form-control pin-card__input"
                        size="4" maxlength="4" (change)="validatePassElement(reserve.uuid)"
                        [value]="reserve.lockerPassword.checkoutPassword" />
                        <div id="validationPassC-{{reserve.uuid}}" class="pin-card__validation d-none">
                          <span>{{'reserves.pinValidation'|traduccion}}</span>
                        </div>
                      </div>
                    </div>
                    @if (reserve.lockerPassword.provisionalPassword) {
                      <div class="col-lg-4 col-md-6 mb-3">
                        <div class="pin-card">
                          <label class="pin-card__label" for="passP-{{reserve.uuid}}">
                            {{'reserves.provisionalPassword'|traduccion}}
                          </label>
                          <div class="pin-card__preview">{{formatPin(reserve, passP.value)}}</div>
                          <input id="passP-{{reserve.uuid}}" #passP type="text" class="form-control pin-card__input"
                            size="4" maxlength="4" (change)="validatePassElement(reserve.uuid)"
                            [value]="reserve.lockerPassword.provisionalPassword" />
                            <div id="validationPassP-{{reserve.uuid}}" class="pin-card__validation d-none">
                              <span>{{'reserves.pinValidation'|traduccion}}</span>
                            </div>
                          </div>
                        </div>
                      }
                      <div class="col-lg-4 col-md-12 mb-3 reserve-card__actions">
                        <button id="btChangeCode-{{reserve.uuid}}" class="btn btn-outline-info btn-round reserve-card__action-btn"
                          (click)="changePasswordOrder(reserve.uuid)">
                          <i class="nc-icon nc-refresh-69 text-dark"></i>
                          {{'reserves.btUpdatePassword'|traduccion}}
                        </button>
                      </div>
                    </div>
                  </div>
                  @if (reserve.payments?.length) {
                    <div class="payments-section">
                      <div class="payments-section__header">
                        {{'reserves.lastPayments'|traduccion}}
                      </div>
                      @for (payment of reserve.payments; track payment) {
                        <div class="payment-card">
                          <div class="row">
                            <div class="col-lg-6 mb-3 mb-lg-0">
                              <div class="payment-card__slot">
                                <div class="payment-card__label">{{'reserves.from'|traduccion}}</div>
                                <div class="payment-card__value">
                                  {{ payment.startTime | date: appService.FORMAT_DATETIME }}
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <div class="payment-card__slot">
                                <div class="payment-card__label">{{'reserves.to'|traduccion}}</div>
                                <div class="payment-card__value">
                                  {{ payment.endTime | date: appService.FORMAT_DATETIME }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row payment-card__prices">
                            <div class="col-md-4 mb-3 mb-md-0">
                              <div class="payment-card__price">
                                <span class="payment-card__label">{{'reserves.basePrice'|traduccion}}</span>
                                <strong>{{ payment.basePrice|number:'1.2-2' }}&euro;</strong>
                              </div>
                            </div>
                            <div class="col-md-4 mb-3 mb-md-0">
                              <div class="payment-card__price">
                                <span class="payment-card__label">{{'reserves.taxPrice'|traduccion}}</span>
                                <strong>{{ payment.taxPrice|number:'1.2-2' }}&euro;</strong>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="payment-card__price payment-card__price--total">
                                <span class="payment-card__label">{{'reserves.totalPrice'|traduccion}}</span>
                                <strong>{{ payment.totalPrice|number:'1.2-2' }}&euro;</strong>
                              </div>
                            </div>
                          </div>
                          <div class="payment-card__actions">
                            <button [disabled]="payment.invoiceNumber==null" class="btn btn-info btn-round text-dark"
                              (click)="downloadTicket(payment.invoiceNumber)">
                              <i class="nc-icon nc-cloud-download-93"></i>
                              {{'reserves.invoice'|traduccion}} {{payment.invoiceNumber || ''}}
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
